import React, { useRef } from 'react';
import { Modal, Box, Button, Container } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import SignatureCanvas from 'react-signature-canvas'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: 200,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  
  const useStyles = makeStyles(theme => ({
    container: {
      [theme.breakpoints.up('sm')]: {
        width: '50%',
        height: 300,
      },
      width: '90%',
      height: '70%',
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center',
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 'auto'
    },
    sigBorder: {
        borderRadius: theme.spacing(3),
        border: '2px solid',
        borderColor: theme.palette.divider,
    },
    signatureCanvas: {
      width: '100%',
      height: '100%',
    }
  }));

const Signature = ({ questionIndex, onValueChange, openSigModal, setOpenSigModal }) => {
    const classes = useStyles();
    const handleClose = () => setOpenSigModal(false);

    const sigCanvas = useRef({});

    const clear = () => sigCanvas.current.clear();
  
    const save = () => {
        let imageURL = sigCanvas.current.getTrimmedCanvas().toDataURL('image/jpeg');
        setOpenSigModal(false);
        onValueChange(questionIndex, imageURL);
    }

    return (
      <Modal
        open={openSigModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className={classes.container}>
            <div className={classes.sigBorder}>
                <SignatureCanvas ref={sigCanvas} canvasProps={{className: classes.signatureCanvas}} backgroundColor='white' />
            </div>
            <div className={classes.footer}>
                <Button variant="outlined" color="primary" onClick={() => clear()}>Clear</Button>
                <Button variant="contained" color="primary" onClick={() => save()}>Save</Button>
            </div>
        </Box>
      </Modal>
    )
}

export default Signature;
